module.exports = __webpack_public_path__ + "img/26.8bbc3862.jpg";